import { COMMUNICATION_CATEGORIES } from '@seen/core/models/communications/constants'
import { PhoneCommunication } from '@seen/core/models/communications/PhoneCommunication'
import { useSearch } from '#src/hooks/useSearch.ts'

interface UsePhoneCallsResult {
  data: PhoneCommunication[] | undefined
  isLoading: boolean
  error: Error | null
}

export function usePhoneCalls(): UsePhoneCallsResult {
  const { data, isLoading, error } = useSearch(PhoneCommunication, {
    _sort: '-_lastUpdated',
    category: COMMUNICATION_CATEGORIES.phoneCall,
    _count: '1000',
  })

  return {
    data,
    isLoading,
    error,
  }
}
